import React, { useState, useEffect } from 'react'
import { Grid, Row, Col, Button, Input, SelectPicker, Form } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { searchExpert } from '../../../redux/actions/assignExpert'
import ExpertDataTable from '../../dataTable/ExpertDataTable'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ExpertListTable from '../../../components/table/expertListTable/ExpertListTable'

export default function SeachExpertWidget({
  schema,
  selectedExpert,
  onClickSelect,
  onClickOnline,
}) {
  const { register, handleSubmit, errors, control, reset } = useForm()
  // const [schema, setSchema] = useState()
  const [expertData, setExpertData] = useState()
  const [currentSeach, setCurrentSeach] = useState()
  const [isReLoading, setIsReLoading] = useState(false)
  const [totalSize, setTotalSize] = useState(schema.totalSize || 0)

  useEffect(() => {
    handleSearchExpert({}, 5, 1)
  }, [])

  const handleSearchExpert = async (data, pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      let request = {
        name: data?.expertName,
        expert: data?.expertise,
        accountType: data?.accountType,
        year: data?.budgetYear && !isNaN(data?.budgetYear) ? parseInt(data?.budgetYear, 10) : null,
      }

      // const request = {
      //   pageSize: pagesize,
      //   currentPage: pagenumber,
      //   name: data?.expertName,
      //   expert: data?.expertise,
      //   accountType: data?.accountType,
      //   year: data?.budgetYear && !isNaN(data.budgetYear) ? parseInt(data.budgetYear, 10) : null,
      // }
      const response = await searchExpert(request, pagenumber, pagesize)
      // console.log('handleSearchExpert', response)
      setTotalSize(response?.model?.totalSize)
      setExpertData(response.model?.itemsList)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const handleReload = (pagesize, pagenumber) => {
    handleSearchExpert(currentSeach, pagesize, pagenumber)
  }

  const onSubmit = (data) => {
    setCurrentSeach(data)
    handleSearchExpert(data, 5, 1)

    //Mock
    // setExpertData(mockData)
  }

  const onClickClearValue = () => {
    console.log({ expertName: '', expertise: '', accountType: '', budgetYear: '' })
    reset({ expertName: '', expertise: '', accountType: '', budgetYear: '' })
    setCurrentSeach('')
  }

  return (
    <>
      <Grid fluid>
        <Form>
          <Row>
            {schema?.searchCondition?.expertName && (
              <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={12} lg={8}>
                <ErrorMessage error={errors[schema.searchCondition.expertName.name]} />
                <p>{schema.searchCondition.expertName.label}</p>
                <Controller
                  key={schema.searchCondition.expertName.name}
                  name={schema.searchCondition.expertName.name}
                  control={control}
                  defaultValue={schema.searchCondition.expertName.value}
                  render={(props) => {
                    return (
                      <Input
                        style={{ width: '100%' }}
                        placeholder={schema.searchCondition.expertName.hint}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
                {/* <Input
                  style={{ width: '100%' }}
                  placeholder={schema.searchCondition.expertName.hint}
                  key={schema.searchCondition.expertName.name}
                  name={schema.searchCondition.expertName.name}
                  inputRef={register}
                /> */}
              </Col>
            )}

            {schema?.searchCondition?.budgetYear && (
              <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={12} lg={8}>
                <ErrorMessage error={errors[schema.searchCondition.budgetYear.name]} />
                <p>{schema.searchCondition.budgetYear.label}</p>
                <Controller
                  key={schema.searchCondition.budgetYear.name}
                  name={schema.searchCondition.budgetYear.name}
                  control={control}
                  defaultValue={schema.searchCondition.budgetYear.value}
                  render={(props) => {
                    return (
                      <Input
                        style={{ width: '100%' }}
                        placeholder={schema.searchCondition.budgetYear.hint}
                        value={props.value}
                        onChange={(value) => {
                          if (isNaN(value)) {
                            return
                          }
                          value.length <= 4 && props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema?.searchCondition?.accountType && (
              <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={12} lg={8}>
                <ErrorMessage error={errors[schema.searchCondition.accountType.name]} />
                <p>{schema.searchCondition.accountType.label}</p>
                <Controller
                  name={schema.searchCondition.accountType.name}
                  control={control}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <SelectPicker
                        searchable
                        size="lg"
                        data={schema.searchCondition.accountType.options}
                        value={props.value}
                        style={{ width: '100%' }}
                        placeholder={schema.searchCondition.accountType.hint}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema?.searchCondition?.expertise && (
              <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={12} lg={8}>
                <ErrorMessage error={errors[schema.searchCondition.expertise.name]} />
                <p>{schema.searchCondition.expertise.label}</p>
                <Controller
                  name={schema.searchCondition.expertise.name}
                  control={control}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <SelectPicker
                        searchable
                        size="lg"
                        data={schema.searchCondition.expertise.options}
                        value={props.value}
                        style={{ width: '100%' }}
                        placeholder={schema.searchCondition.expertise.hint}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {/* <Col style={{ marginBottom: 10, marginTop: 10 }}>
              <Button appearance="ghost" onClick={handleSubmit(onSubmit)}>
                ค้นหา
              </Button>
              <Button style={{ marginLeft: 20 }} appearance="ghost" onClick={onClickClearValue}>
                ล้างข้อมูล
              </Button>
            </Col> */}
          </Row>
          <Row>
            <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={6} lg={4}>
              <SaveButton icon="search" block onClick={handleSubmit(onSubmit)}>
                {`ค้นหา`}
              </SaveButton>
            </Col>
            <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={6} lg={4}>
              <CancelButton block onClick={onClickClearValue}>
                {'ล้างข้อมูล'}
              </CancelButton>
            </Col>
          </Row>
        </Form>
      </Grid>
      <br />
      <ExpertListTable
        data={expertData}
        selectedExpert={selectedExpert}
        isEditable
        // /isSubProject={false}
        onClickSelect={onClickSelect}
        onClickOnline={onClickOnline}
        onReload={handleReload}
        totalSize={totalSize}
        loading={isReLoading}
      />
      {/* <ExpertDataTable
        header="รายชื่อผู้ทรงคุณวุฒิ"
        data={expertData || []}
        isEditable={true}
        selectedExpert={selectedExpert}
        onClickSelect={onClickSelect}
        onClickOnline={onClickOnline}
        onReload={handleReload}
        pagination={true}
        totalSize={expertData?.length}
        loading={isReLoading}
        isHideWorkload={false}
      /> */}
    </>
  )
}
